import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";

import {
    SpsTable,
    SpsTableHead,
    SpsTableRow,
    SpsTableBody,
    SpsTableCell,
    SpsTableHeader,
    SpsI,
    SpsTooltip,
} from "@spscommerce/ds-react";

import { SortDirection, TooltipShowTrigger } from "@spscommerce/ds-shared";
import { Position } from "@spscommerce/positioning";

const TooltipRenderer = (props) => {
    const { tooltipPreset } = props;
    const ref = useRef(null);

    if (tooltipPreset === "new_audience") {
        return (
            <>
                <span ref={ref}>
                    <SpsI icon="info-circle" size="sm" className="ml-2 blue300" />
                </span>
                <SpsTooltip
                    for={ref}
                    showOn={TooltipShowTrigger.CLICK}
                    position={Position.TOP_MIDDLE}
                    offset={{
                        x: 6,
                    }}
                >
                    <span>
                        Please note https://spscommerce.com is a new audience as of 6/1/25. More
                        details about the change can be found{" "}
                        <a
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://developercenter.spscommerce.com/#/docs/new-authentication-docs/client-updates-for-enhanced-security"
                        >
                            here
                        </a>
                        .
                    </span>
                </SpsTooltip>
            </>
        );
    }

    return <></>;
};

const TableWrapper = (props) => {
    const data = props.tableData;
    const dataKeys = Object.keys(data[0]);
    const className = props.className || "";
    const wrapColumns = props.wrapColumns || {};

    const [sortedData, setSortedData] = useState(data);

    function sortItems([newSort]) {
        const { key, direction } = newSort;
        sortedData.sort(
            (a, b) =>
                (direction === SortDirection.ASCENDING ? 1 : -1) * (a[key] >= b[key] ? 1 : -1),
        );
        setSortedData([...sortedData]);
    }

    return (
        <SpsTable className={className} onSortChange={sortItems}>
            <SpsTableHead>
                <SpsTableRow>
                    {dataKeys.map((key, index) => (
                        <SpsTableHeader sortKey={key} key={index}>
                            {key.charAt(0).toUpperCase() + key.slice(1)}
                        </SpsTableHeader>
                    ))}
                </SpsTableRow>
            </SpsTableHead>
            <SpsTableBody>
                {sortedData.map((obj, rowIndex) => {
                    return (
                        <SpsTableRow key={rowIndex}>
                            {dataKeys.map((key, columnIndex) => {
                                const cellId = `${rowIndex}-${columnIndex}`;
                                return (
                                    <SpsTableCell
                                        key={cellId}
                                        wrap={
                                            wrapColumns && wrapColumns[key]
                                                ? wrapColumns[key]
                                                : null
                                        }
                                    >
                                        {typeof obj[key] === "object" && obj[key].content ? (
                                            <>
                                                {parse(obj[key].content.toString())}
                                                <TooltipRenderer
                                                    tooltipPreset={obj[key].tooltipPreset}
                                                />
                                            </>
                                        ) : (
                                            parse(obj[key].toString())
                                        )}
                                    </SpsTableCell>
                                );
                            })}
                        </SpsTableRow>
                    );
                })}
            </SpsTableBody>
        </SpsTable>
    );
};

TableWrapper.propTypes = {
    tableData: PropTypes.array,
    className: PropTypes.string,
    wrapColumns: PropTypes.object,
};

export default TableWrapper;
